module.exports = __webpack_public_path__ + "static/img/gwiazda.da84f167.webp";